// src/utils/CountryMapper.js

const SUFFIX_TO_FLAG = {
  // Americas
  'SA': '🇧🇷', // Brazil
  'MX': '🇲🇽', // Mexico
  'TO': '🇨🇦', // Canada
  'CN': '🇨🇦', // Canada (alternate)
  'BA': '🇦🇷', // Argentina
  'SN': '🇨🇱', // Chile
  
  // Europe
  'L':  '🇬🇧', // London (UK)
  'PA': '🇫🇷', // Paris (France)
  'DE': '🇩🇪', // Germany (Xetra)
  'F':  '🇩🇪', // Frankfurt
  'AS': '🇳🇱', // Amsterdam (Netherlands)
  'BR': '🇧🇪', // Brussels (Belgium)
  'MI': '🇮🇹', // Milan (Italy)
  'MC': '🇪🇸', // Madrid (Spain)
  'LS': '🇵🇹', // Lisbon (Portugal)
  'SW': '🇨🇭', // Switzerland
  'HE': '🇫🇮', // Helsinki
  'ST': '🇸🇪', // Stockholm
  'OL': '🇳🇴', // Oslo
  'IR': '🇮🇪', // Ireland
  'VI': '🇦🇹', // Vienna Austria


  // Asia / Pacific
  'T':  '🇯🇵', // Tokyo
  'HK': '🇭🇰', // Hong Kong
  'SS': '🇨🇳', // Shanghai
  'SZ': '🇨🇳', // Shenzhen
  'KS': '🇰🇷', // Korea
  'TW': '🇹🇼', // Taiwan
  'SI': '🇸🇬', // Singapore
  'AX': '🇦🇺', // Australia
  'NZ': '🇳🇿', // New Zealand
  'NS': '🇮🇳', // India
  'JK': '🇮🇩', // Indonesia 

  // Middle East
  'TA': '🇮🇱', // Tel Aviv
  'QA': '🇶🇦', // Qatar
  'AE': '🇦🇪', // UAE
  'SR': '🇸🇦', // Saudi Arabia


  // Africa

  'JO': '🇿🇦', // South Africa 
};

export const getFlagByTicker = (ticker) => {
  if (!ticker) return '🇺🇸'; // Default to US
  
  const parts = ticker.split('.');
  if (parts.length === 1) return '🇺🇸'; // No suffix = US (NYSE/NASDAQ)
  
  const suffix = parts[parts.length - 1];
  return SUFFIX_TO_FLAG[suffix] || '🌐'; // Default global if unknown
};